import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ before, after, label, testid }) => {
  const [pos, setPos] = useState(50);
  const box = useRef(null);
  const move = (x) => {
    const r = box.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100)));
  };
  const drag = (e) => {
    const onMove = (ev) => move(ev.touches ? ev.touches[0].clientX : ev.clientX);
    const stop = () => { window.removeEventListener("pointermove", onMove); window.removeEventListener("pointerup", stop); };
    onMove(e);
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", stop);
  };
  return (
    <figure className="space-y-2" data-testid={testid}>
      <div ref={box} onPointerDown={drag} className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl bg-[#F1EDE6] select-none touch-none cursor-ew-resize">
        <img src={after} alt={`${label} dopo`} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
        <img src={before} alt={`${label} prima`} draggable={false} className="absolute inset-0 h-full w-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
        <span className="absolute top-3 left-3 rounded-full bg-black/70 text-white text-xs px-3 py-1">Prima</span>
        <span className="absolute top-3 right-3 rounded-full bg-white/90 text-black text-xs px-3 py-1">Dopo</span>
        <div className="absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-white shadow flex items-center justify-center"><MoveHorizontal className="h-5 w-5" /></span>
        </div>
        <input type="range" min={0} max={100} value={pos} onChange={(e) => setPos(Number(e.target.value))} className="sr-only" aria-label={`Confronto ${label}`} data-testid={`${testid}-range`} />
      </div>
      {label && <figcaption className="text-sm font-medium">{label}</figcaption>}
    </figure>
  );
};
